import React, { Component } from 'react';
import {robots} from './robots.js';
import CardList from './CardList';
import SearchBox from './SearchBox.js';
import './App.css';
import Scroll from './Scroll'

class App extends Component  {
	constructor() {
		super()
		this.state = {
			robots: [],
			searchfield: ''
		}
	}
	componentDidMount() {
		//this.setState({robots: robots})
		fetch('https://jsonplaceholder.typicode.com/users').then(response => {
			return response.json();
		})
		.then(users => {
			this.setState({robots: robots})
		})
	}
	onSearchChange = (event) => {
		this.setState({searchfield: event.target.value })
		//console.log(filteredRobots);
		
	}
	render() {
		const filteredRobots = this.state.robots.filter(robot => {
			return robot.name.toLowerCase().includes(this.state.searchfield.toLowerCase())
		});
		if (this.state.robots.length === 0) {
			return <h1 className="tc">LOADING</h1>
		}
		else {
			return (
          <div className="tc">
           <h1 className="f1">RoboFriends</h1>
           <SearchBox searchChange={this.onSearchChange} />
           <Scroll>
             <CardList robots={ filteredRobots } />
           </Scroll>  
          </div>  
        );
		}
		
	}
  
}




export default App;
